import template from './bulk-update.template.html'

export default {
  templateUrl: template,
  controller: class {
    constructor(redemptionBulkUpdateService, FileUploader, NotificationService) {
      this.service = redemptionBulkUpdateService;
      this.fileUploader = new FileUploader();
      this.notificationService = NotificationService;
      this.fileToUpload = null;
      this.failedUploadMessage = null;
      this.errors = [];
    }

    $onInit() {
      this.fileUploader.onAfterAddingFile = (file) => {
        this.fileToUpload = file._file;
      }
    }

    uploadFile() {
      this.clearErrorMessages();
      this.service
          .redeem(this.fileToUpload)
          .then((res) => {
            this.errors = res.data.errors;
            this.notificationService.success('File imported. Please review the errors presented on the table if there was any')
          })
          .catch((res) => {
            this.failedUploadMessage = res.data.errors[0].message;
            this.notificationService.error('Error importing the file.')
          });
    }

    clearErrorMessages() {
      this.errors = [];
      this.failedUploadMessage = null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/redemptions/bulk-update/bulk-update.component.js